import React, { FC, PropsWithChildren } from 'react';
import styles from './InputWrapper.module.scss';

export interface InputWrapperProps {
  label: string;
}

const InputWrapper: FC<PropsWithChildren<InputWrapperProps>> = ({ label, children }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.label}>{label}</p>
      {children}
    </div>
  );
};

export default InputWrapper;
